export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7525.f38485a9.jpg";